<template>
  <div>
    <card>
        <div class="row">
            <div class="col" style="margin-bottom:10px">
                <router-link :to="'crea-prestazione?idCliente='+idCliente"><button class="btn float-left" type="button" style="background:#00467f">CREA PRESTAZIONE</button></router-link>
            </div>
        </div>
        <table class="table tablesorter" id="tabella" style="text-align: center">
            <thead>
                <tr>
                    <th></th>
                    <th>Data Prestazione</th>
                    <th>Causale</th>
                    <th>Tipo Prestazione</th>
                    <th>Grado di rischio</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr class="row-color" v-for="(valori, index) in allPrestazioni" v-bind:key="valori.ID">
                    <td @click="caricaPrestazione(valori.ID, index)">
                        <i class="tim-icons icon-pencil" style="color:#00467f"></i>
                    </td>
                    <td>{{getDate(valori.DATA_PRESTAZIONE)}}</td>
                    <td>{{valori.CAUSALE}}</td>
                    <td>{{valori.ANTIRIC_PRESTAZIONE_TIPO.NOME}}</td>
                    <td></td>
                    <td>
                        <!-- SE TAB_B==NULL E PRESTAZIONE_TIPO==2 PALLINO ROSSO ALTRIMENTI VERDE
                        <span v-if=""> 
                            <img src="@/assets/img/green.png" style="width:20px">
                        </span> -->
                        <span v-if="valori.TAB_B == null && valori.ANTIRIC_PRESTAZIONE_TIPO.TIPO_TABELLA==2">
                            <router-link :to="'valutazione-b?idCliente='+idCliente+'&idPrestazione='+valori.ID">
                                <i class="fa fa-bold" style="font-size:16px;color:red"></i>
                            </router-link>
                        </span>
                        <span v-else-if="valori.TAB_B != null && valori.ANTIRIC_PRESTAZIONE_TIPO.TIPO_TABELLA==2">
                            <router-link :to="'valutazione-b?idCliente='+idCliente+'&idPrestazione='+valori.ID+'&idTabB='+valori.TAB_B">
                                <i class="fa fa-bold" style="font-size:16px;color:green"></i>
                            </router-link>
                        </span>
                        <span v-else>
                            <img src="@/assets/img/green.png" style="width:30px">
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <router-link :to="'riassunto?idCliente='+idCliente+'&update=true'"><button class="btn float-right" type="button" style="margin-top: 20px;margin-right:20px;background:#00467f;">Avanti</button></router-link>
        <router-link :to="'/anagrafica-soggetti?idCliente='+idCliente" class="btn float-right" style="margin-top: 20px;margin-right:10px;background:#00467f">Indietro</router-link>
    </card>
    <hr>
    <card v-if="idPrestazione != null">
        <h3>Dati Prestazione</h3>
        <hr>
        <form>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="causale">Causale<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="causale" placeholder="causale">
                </div>
                <div class="form-group col-md-6">
                    <label for="prestazione_professionale_fornita">Prestazione professionale fornita<span style="color:#ff0000">*</span></label>
                    <!-- <input type="text" class="form-control" v-model="prestazione_professionale_fornita"> -->
                    <select class="form-control" v-model="prestazione_professionale_fornita">
                        <option v-for="(valori, index) in prestazioni_tipo" v-bind:key="valori.ID" :value="valori.ID">{{index+1}}. {{valori.NOME}}</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="natura">Natura<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="natura" placeholder="natura">
                </div>
                <div class="form-group col-md-6">
                    <label for="scopo">Scopo<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="scopo" placeholder="scopo">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="data_prestazione">Data Prestazione<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_prestazione">
                </div>
                <div class="form-group col-md-6">
                    <label for="data_cessazione">Data Cessazione<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_cessazione">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="modalita_pagamento">Modalità Pagamento<span style="color:#ff0000">*</span></label>
                    <select v-model="modalita_pagamento" class="form-control">
                        <option value="contanti">Contanti</option>
                        <option value="bonifico">Bonifico</option>
                        <option value="sepa">SEPA</option>
                        <option value="pos">POS</option>
                    </select>
                    
                </div>
                <div class="form-group col-md-4">
                    <label for="divisa">Divisa<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="divisa">
                </div>
                <div class="form-group col-md-4">
                    <!-- <label for="importo">Importo<span style="color:#ff0000">*</span></label>
                    <input type="number" class="form-control" v-model="importo"> -->
                    <label for="importo">Importo<span style="color:#ff0000">*</span></label>
                    <div class="input-icon">
                        <!-- <input type="text" class="form-control" placeholder="0.00"> -->
                        <input type="number" class="form-control" v-model="importo" id="importo" placeholder="0.00">
                        <i>€</i>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="soggetto_per_cliente">Soggetto che opera per conto del Cliente<span style="color:#ff0000">*</span></label>
                    <select v-model="soggetto_per_cliente" class="form-control">
                        <option>...</option>
                        <option>...</option>
                    </select>
                </div>
                <div class="form-group col-md-6">
                    <label for="legame">Legame<span style="color:#ff0000">*</span></label>
                    <select v-model="legame" class="form-control">
                        <option>...</option>
                        <option>...</option>
                    </select>
                </div>
            </div>
        </form>
        
        <hr>
        <h3>Altri dati</h3>
         <div class="form-row">
            <div class="form-group col-md">
                <label for="note">Note</label>
                <textarea lass="form-control" v-model="note" id="note" rows="3" style="width:100%;border-radius:7px"></textarea>
            </div>
        </div>
        <!-- <div class="row" style="margin-top:10px;margin-left:10px">
            <span>Note:</span>
        </div>
        <div class="row" style="margin-top:10px;margin-left:10px">
            <textarea type="textarea" v-model="note" style="margin-left:5px;margin-right:5px" rows="5" cols="150"></textarea>
        </div> -->
        <button class="btn float-right" type="button" v-on:click="salvaValori()" style="margin-top:20px;margin-right:10px;background:#00467f">Salva</button>
        <router-link  v-if="prestazione.TAB_B == null && allPrestazioni[i].ANTIRIC_PRESTAZIONE_TIPO.TIPO_TABELLA==2" :to="'valutazione-b?idCliente='+idCliente+'&idPrestazione='+idPrestazione"><button class="btn float-right" type="button" style="margin-top: 20px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        <!-- <router-link  v-else-if="prestazione.TAB_B != null" :to="'valutazione-b?idCliente='+idCliente+'&idPrestazione='+idPrestazione+'&idTabB='+idTabB"><button class="btn float-right" type="button" style="margin-top: 20px;margin-right:20px;background:#00467f">Avanti</button></router-link> -->
        
        <router-link :to="'/anagrafica-soggetti?idCliente='+idCliente" class="btn float-right" style="margin-top: 20px;margin-right:10px;background:#00467f">Indietro</router-link>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Cards/Card.vue';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';
import Services from '@/services/Services';
import moment from 'moment';

export default {
    components: {
        Card
    },

    data() {
        return {
            causale: null,
            prestazione_professionale_fornita: null,
            natura: null,
            scopo: null,
            data_prestazione: null,
            data_cessazione: null,
            modalita_pagamento: null,
            divisa : null,
            importo: null,
            soggetto_per_cliente: null,
            legame: null,
            note: null,

            idCliente: null,
            idPrestazione: null,
            idTabB: null,

            allPrestazioni: [],
            prestazione: [],
            i: null,

            prestazioni_tipo: [],
        }
    },

    methods: {
        caricaPrestazione: async function(idPrestazione, index) {
            let errore = 0;
            this.i = index;
            console.log(`i= ${this.i}`);
            this.idPrestazione = idPrestazione;
            await AntiriciclaggioServices.getPrestazione(this.idCliente, idPrestazione) 
            .then(response => { this.prestazione= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.caricaPrestazione(); }
            }
            console.log("prestazione:");
            console.log(this.prestazione);
            this.causale = this.prestazione.CAUSALE;
            this.prestazione_professionale_fornita = this.prestazione.PRESTAZIONE_FORNITA;
            this.natura = this.prestazione.NATURA;
            this.scopo = this.prestazione.SCOPO;
            this.data_prestazione = this.prestazione.DATA_PRESTAZIONE;
            this.data_cessazione = this.prestazione.DATA_CESSAZIONE;
            this.modalita_pagamento = this.prestazione.MODALITA_PAGAMENTO;
            this.divisa = this.prestazione.DIVISA;
            this.importo = this.prestazione.IMPORTO;
            this.soggetto_per_cliente = this.prestazione.SOGGETTO_OPERA_CLIENTE;
            this.legame = this.prestazione.LEGAME;
            this.note = this.prestazione.NOTE;
            this.idTabB = this.prestazione.TAB_B;
            console.log(`prestazione.ANTIRIC_PRESTAZIONE_TIPO.TIPO_TABELLA= ${this.allPrestazioni[index].ANTIRIC_PRESTAZIONE_TIPO.TIPO_TABELLA}`);
            // prestazione.TAB_B == null && allPrestazioni[i].ANTIRIC_PRESTAZIONE_TIPO.TIPO_TABELLA==2
            console.log(`i = ${this.i}`);
            console.log(`prestazione.TAB_B == ${this.prestazione.TAB_B} && allPrestazioni[i].ANTIRIC_PRESTAZIONE_TIPO.TIPO_TABELLA== ${this.allPrestazioni[this.i].ANTIRIC_PRESTAZIONE_TIPO.TIPO_TABELLA}`)
        },

        checkData: function() {
            if ( this.causale == null || this.prestazione_professionale_fornita == null || this.natura == null ||  this.scopo == null 
                ||  this.data_prestazione == null || this.data_cessazione == null || this.modalita_pagamento == null || this.divisa == null 
                || this.importo == null || this.soggetto_per_cliente == null || this.legame == null) {
                    return false;
            } else {
                return true;
            }
        },

        getAllPrestazioni: async function() {
            let errore = 0;
            await AntiriciclaggioServices.getAllPrestazioni(this.idCliente)
            .then(response => { this.allPrestazioni= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.getAllPrestazioni(this.idCliente); }
            }
            console.log(`allPrestazioni`);
            console.log(this.allPrestazioni);
        },

        getDate(date) {
            return moment(String(date)).format('DD/MM/YYYY');
        },

        getPrestazioniTipo: async function(){
            let errore = 0;
            await AntiriciclaggioServices.getPrestazioniTipo()
            .then(response => { this.prestazioni_tipo = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.getPrestazioniTipo(); }
            }
            // console.log("prestazioni tipo");
            // console.log(this.prestazioni_tipo);
        },

        salvaValori: async function() {
            if (this.checkData()) {
                let dati = [];
                let errore = 0;
                dati.push({ 
                    CAUSALE: this.causale, PRESTAZIONE_FORNITA: this.prestazione_professionale_fornita, NATURA: this.natura, SCOPO: this.scopo, 
                    DATA_PRESTAZIONE: this.data_prestazione, DATA_CESSAZIONE: this.data_cessazione, MODALITA_PAGAMENTO: this.modalita_pagamento, DIVISA: this.divisa, 
                    IMPORTO: this.importo, SOGGETTO_OPERA_CLIENTE: this.soggetto_per_cliente, LEGAME: this.legame, NOTE: this.note 
                });
                let datiJSON=JSON.stringify(dati[0]);
                let caricaValori = []
                await AntiriciclaggioServices.updatePrestazione(this.idCliente, this.idPrestazione, datiJSON)
                .then(response => { caricaValori= response.data})
                .catch( function (error) {
                    if(error.response.status == 401){
                    errore = error.response.status;
                    }
                });
                if (errore == 401) {
                    let value = await Services.refreshTokenFunction();
                    if (value) { await this.salvaValori(); }
                }
                await this.getAllPrestazioni();                
            } else {
                alert("Compilare tutti i dati!");
            }
        },

        main: async function() {
            this.idCliente = this.$route.query.idCliente; 
            await this.getPrestazioniTipo();
            await this.getAllPrestazioni();
        },
    },

    mounted() {
        this.main();
    } 
};
</script>
<style scoped>
    label {
        font-size: 16px;
    }
</style>